import React from "react";
import AllAccountMovements from "./AllAccountMovements";
function ClosedAccountMovements(props) {
	return <AllAccountMovements {...props} IsClosedAccounts={true} />;
}
export default ClosedAccountMovements;